var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ops-section" },
    [
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c(
            "div",
            {
              staticClass: "ops-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("i", { staticClass: "el-icon-setting" }),
              _vm._v(" "),
              _c("span", [_vm._v("基本设置")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-card",
            { staticClass: "ops-block", attrs: { shadow: "never" } },
            [
              _c(
                "div",
                {
                  staticClass: "block-title",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_vm._v("打赏等级限制")]
              ),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  attrs: {
                    model: _vm.form,
                    "label-width": "120px",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "打赏限制" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.form.rewardLevelLimit.minGiveLevel,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.rewardLevelLimit,
                                "minGiveLevel",
                                $$v
                              )
                            },
                            expression: "form.rewardLevelLimit.minGiveLevel",
                          },
                        },
                        _vm._l(_vm.levelOptions, function (level) {
                          return _c("el-option", {
                            key: level.value,
                            attrs: { label: level.label, value: level.value },
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "tip gap-left" }, [
                        _vm._v("用户需大于此等级才可以进行打赏"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "被打赏限制" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.form.rewardLevelLimit.minReceiveLevel,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.rewardLevelLimit,
                                "minReceiveLevel",
                                $$v
                              )
                            },
                            expression: "form.rewardLevelLimit.minReceiveLevel",
                          },
                        },
                        _vm._l(_vm.levelOptions, function (level) {
                          return _c("el-option", {
                            key: "r-" + level.value,
                            attrs: { label: level.label, value: level.value },
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "tip gap-left" }, [
                        _vm._v("用户需大于此会员等级才可被打赏"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-card",
            { staticClass: "ops-block", attrs: { shadow: "never" } },
            [
              _c(
                "div",
                {
                  staticClass: "block-title",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_vm._v("打赏基础设置")]
              ),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  attrs: {
                    model: _vm.form,
                    "label-width": "140px",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "每日打赏次数限制" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, max: 9999 },
                        model: {
                          value: _vm.form.basicSettings.dailyRewardLimit,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.basicSettings,
                              "dailyRewardLimit",
                              $$v
                            )
                          },
                          expression: "form.basicSettings.dailyRewardLimit",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "tip gap-left" }, [
                        _vm._v("次"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "可选打赏积分值" } }, [
                    _c(
                      "div",
                      { staticClass: "availableRewardPoints" },
                      [
                        _c("el-input", {
                          model: {
                            value:
                              _vm.form.basicSettings.availableRewardPoints
                                .first,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.basicSettings.availableRewardPoints,
                                "first",
                                $$v
                              )
                            },
                            expression:
                              "form.basicSettings.availableRewardPoints.first",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          model: {
                            value:
                              _vm.form.basicSettings.availableRewardPoints
                                .second,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.basicSettings.availableRewardPoints,
                                "second",
                                $$v
                              )
                            },
                            expression:
                              "form.basicSettings.availableRewardPoints.second",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          model: {
                            value:
                              _vm.form.basicSettings.availableRewardPoints
                                .third,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.basicSettings.availableRewardPoints,
                                "third",
                                $$v
                              )
                            },
                            expression:
                              "form.basicSettings.availableRewardPoints.third",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          model: {
                            value:
                              _vm.form.basicSettings.availableRewardPoints
                                .fourth,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.basicSettings.availableRewardPoints,
                                "fourth",
                                $$v
                              )
                            },
                            expression:
                              "form.basicSettings.availableRewardPoints.fourth",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-card",
            { staticClass: "ops-block", attrs: { shadow: "never" } },
            [
              _c(
                "div",
                {
                  staticClass: "block-title",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_vm._v("修改个人资料/敏感词")]
              ),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  attrs: {
                    model: _vm.form,
                    "label-width": "160px",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "修改个人资料" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0 },
                        model: {
                          value: _vm.form.profileAndSensitive.changeProfileCost,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.profileAndSensitive,
                              "changeProfileCost",
                              $$v
                            )
                          },
                          expression:
                            "form.profileAndSensitive.changeProfileCost",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "敏感词" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 4,
                          placeholder: "请输入敏感词，多个以英文逗号分隔",
                        },
                        model: {
                          value: _vm.form.profileAndSensitive.sensitiveWords,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.profileAndSensitive,
                              "sensitiveWords",
                              $$v
                            )
                          },
                          expression: "form.profileAndSensitive.sensitiveWords",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "tip" }, [
                        _vm._v("*，每个词汇之间半角逗号','分割"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-card",
            { staticClass: "ops-block", attrs: { shadow: "never" } },
            [
              _c(
                "div",
                {
                  staticClass: "block-title",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_vm._v("等级对应的打赏 / 被赏积分限制")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.levelLimits, border: "", size: "small" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "label", label: "会员等级" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "dailyGive", label: "每日可打赏积分" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              model: {
                                value: scope.row.dailyGive,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "dailyGive", $$v)
                                },
                                expression: "scope.row.dailyGive",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "dailyReceive",
                      label: "每日可接受打赏积分",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              model: {
                                value: scope.row.dailyReceive,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "dailyReceive", $$v)
                                },
                                expression: "scope.row.dailyReceive",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-card",
            { staticClass: "ops-block", attrs: { shadow: "never" } },
            [
              _c(
                "div",
                {
                  staticClass: "block-title",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_vm._v("卡转账设置")]
              ),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  attrs: {
                    model: _vm.form,
                    "label-width": "120px",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "卡转账规则" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", rows: 8 },
                        model: {
                          value: _vm.form.cardTransferSettings.rules,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.cardTransferSettings,
                              "rules",
                              $$v
                            )
                          },
                          expression: "form.cardTransferSettings.rules",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "卡转账使用规则" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 6,
                          placeholder: "请输入",
                        },
                        model: {
                          value: _vm.form.cardTransferSettings.usageRules,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.cardTransferSettings,
                              "usageRules",
                              $$v
                            )
                          },
                          expression: "form.cardTransferSettings.usageRules",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ops-actions" },
            [
              _c("el-button", { on: { click: _vm.handleReset } }, [
                _vm._v("取消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }